import React, { useContext, useRef } from 'react';
import { AppTopbarRef, ChildContainerProps } from '../types';
import { classNames } from 'primereact/utils';
import AppSidebar from './AppSidebar';
import { LayoutContext } from './context/layoutcontext';
import AppTopbar from './AppTopbar';
import AppProfileSidebar from './AppProfileSidebar';
import AppBreadCrumb from './AppBreadCrumb';
import './layout.module.css';

const Layout = (props: ChildContainerProps) => {
  const { layoutConfig, layoutState, setLayoutState, isSlim, isSlimPlus, isHorizontal, isDesktop } = useContext(LayoutContext);
  const topbarRef = useRef<AppTopbarRef>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);

  let timeout: ReturnType<typeof setTimeout> | null = null;

  const onMouseEnter = () => {
    if (!layoutState.anchored) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      setLayoutState(prevLayoutState => ({
        ...prevLayoutState,
        sidebarActive: true,
      }));
    }
  };

  const onMouseLeave = () => {
    if (!layoutState.anchored) {
      if (!timeout) {
        timeout = setTimeout(
          () =>
            setLayoutState(prevLayoutState => ({
              ...prevLayoutState,
              sidebarActive: false,
            })),
          300,
        );
      }
    }
  };

  const containerClass = classNames({
    'layout-light': layoutConfig.colorScheme === 'light',
    'layout-dim': layoutConfig.colorScheme === 'dim',
    'layout-dark': layoutConfig.colorScheme === 'dark',
    'layout-colorscheme-menu': layoutConfig.menuTheme === 'colorScheme',
    'layout-primarycolor-menu': layoutConfig.menuTheme === 'primaryColor',
    'layout-transparent-menu': layoutConfig.menuTheme === 'transparent',
    'layout-overlay': layoutConfig.menuMode === 'overlay',
    'layout-static': layoutConfig.menuMode === 'static',
    'layout-slim': layoutConfig.menuMode === 'slim',
    'layout-slim-plus': layoutConfig.menuMode === 'slim-plus',
    'layout-horizontal': layoutConfig.menuMode === 'horizontal',
    'layout-reveal': layoutConfig.menuMode === 'reveal',
    'layout-drawer': layoutConfig.menuMode === 'drawer',
    'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
    'layout-overlay-active': layoutState.overlayMenuActive,
    'layout-mobile-active': layoutState.staticMenuMobileActive,
    'p-input-filled': layoutConfig.inputStyle === 'filled',
    'p-ripple-disabled': !layoutConfig.ripple,
    'layout-sidebar-active': layoutState.sidebarActive,
    'layout-sidebar-anchored': layoutState.anchored,
  });

  return (
    <div className="admin-theme">
      <React.Fragment>
        <div className={classNames('layout-container', containerClass)}>
          <div ref={sidebarRef} className="layout-sidebar" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <AppSidebar />
          </div>
          <div className="layout-content-wrapper">
            <AppTopbar ref={topbarRef} />

            <AppBreadCrumb className="content-breadcrumb"></AppBreadCrumb>
            <div className="layout-content">{props.children}</div>
          </div>
          <AppProfileSidebar />
          {/*<AppConfig />*/}
          <div className="layout-mask"></div>
        </div>
      </React.Fragment>
    </div>
  );
};

export default Layout;
